/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSourcesControllerUpdateMutationRequest, ApplicationSourcesControllerUpdateMutationResponse, ApplicationSourcesControllerUpdatePathParams, ApplicationSourcesControllerUpdate400, ApplicationSourcesControllerUpdate401, ApplicationSourcesControllerUpdate403, ApplicationSourcesControllerUpdate404 } from "../../models/checklistsController/ApplicationSourcesControllerUpdate";

function getApplicationSourcesControllerUpdateUrl(id: ApplicationSourcesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-application-sources/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist application source
 * {@link /api/v1/checklist-application-sources/:id}
 */
export async function applicationSourcesControllerUpdate(id: ApplicationSourcesControllerUpdatePathParams["id"], data?: ApplicationSourcesControllerUpdateMutationRequest, config: Partial<RequestConfig<ApplicationSourcesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ApplicationSourcesControllerUpdateMutationResponse, ResponseErrorConfig<ApplicationSourcesControllerUpdate400 | ApplicationSourcesControllerUpdate401 | ApplicationSourcesControllerUpdate403 | ApplicationSourcesControllerUpdate404>, ApplicationSourcesControllerUpdateMutationRequest>({ method : "PATCH", url : getApplicationSourcesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}